/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { SetAiCredentialMutationRequest, SetAiCredentialMutationResponse, SetAiCredentialPathParams, SetAiCredential400, SetAiCredential401, SetAiCredential403, SetAiCredential404, SetAiCredential409, SetAiCredential422, SetAiCredential500 } from "../../types/platformBillingController/SetAiCredential.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { setAiCredential } from "../../client/platformBillingController/setAiCredential.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const setAiCredentialMutationKey = () => [{ url: '/api/organizations/:organizationId/platform-billing/credentials' }] as const

export type SetAiCredentialMutationKey = ReturnType<typeof setAiCredentialMutationKey>

export function setAiCredentialMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SetAiCredentialMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = setAiCredentialMutationKey()
        return mutationOptions<SetAiCredentialMutationResponse, ResponseErrorConfig<SetAiCredential400 | SetAiCredential401 | SetAiCredential403 | SetAiCredential404 | SetAiCredential409 | SetAiCredential422 | SetAiCredential500>, {organizationId: SetAiCredentialPathParams["organizationId"], data: SetAiCredentialMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, data }) => {
            return setAiCredential(organizationId, data, config)
          },
        })

}

/**
 * @summary Set (create or replace) a BYOK provider key
 * {@link /api/organizations/:organizationId/platform-billing/credentials}
 */
export function useSetAiCredential<TContext>(options: 
{
  mutation?: UseMutationOptions<SetAiCredentialMutationResponse, ResponseErrorConfig<SetAiCredential400 | SetAiCredential401 | SetAiCredential403 | SetAiCredential404 | SetAiCredential409 | SetAiCredential422 | SetAiCredential500>, {organizationId: SetAiCredentialPathParams["organizationId"], data: SetAiCredentialMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SetAiCredentialMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? setAiCredentialMutationKey()

          const baseOptions = setAiCredentialMutationOptions(config) as UseMutationOptions<SetAiCredentialMutationResponse, ResponseErrorConfig<SetAiCredential400 | SetAiCredential401 | SetAiCredential403 | SetAiCredential404 | SetAiCredential409 | SetAiCredential422 | SetAiCredential500>, {organizationId: SetAiCredentialPathParams["organizationId"], data: SetAiCredentialMutationRequest}, TContext>
          

          return useMutation<SetAiCredentialMutationResponse, ResponseErrorConfig<SetAiCredential400 | SetAiCredential401 | SetAiCredential403 | SetAiCredential404 | SetAiCredential409 | SetAiCredential422 | SetAiCredential500>, {organizationId: SetAiCredentialPathParams["organizationId"], data: SetAiCredentialMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SetAiCredentialMutationResponse, ResponseErrorConfig<SetAiCredential400 | SetAiCredential401 | SetAiCredential403 | SetAiCredential404 | SetAiCredential409 | SetAiCredential422 | SetAiCredential500>, {organizationId: SetAiCredentialPathParams["organizationId"], data: SetAiCredentialMutationRequest}, TContext>
      
}